export class NetEasyError extends Error {
    event;
    data;
    constructor(event, data) {
        super(`NetEasyError: ${event} ${JSON.stringify(data)}`);
        this.event = event;
        this.data = data;
    }
}
//# sourceMappingURL=NetEasyError.js.map